<!-- <div class="recent-tag-cont">
<h4>Recents</h4>
<div class="recent-tag" *ngFor="let tag of this.implRef.recentsTagsList" [ngClass]="{'bluredTag':tag.blurTag}">
  <span class="tag-name">{{tag.tag}}</span>
  <span class="add-tag-btn Neueaddfilefilled" (click)="addTagToObject(tag.tag)"></span>
</div>
</div> -->
<div class="tags-recents-main">
  <h2>Recents</h2>
  @if (!loader) {
    <div>
      @for (tag of implRef.recentsTagsList; track tag) {
        <ul>
          <li [ngClass]="{'off':tag.blurTag}" (click)="addTagToObject(tag.tag)">{{tag.tag}}<span class="Neueaddfilefilled" title="Remove tag"></span></li>
        </ul>
      }
      @if (implRef.recentsTagsList?.length == 0) {
        <p>No recent tags available</p>
      }
    </div>
  }
  @if (loader) {
    <div class="spinner_loader_recent">
      <div class="small_loader"></div>
    </div>
  }
</div>